module.exports = __webpack_public_path__ + "img/18.64f73e24.png";